import React from "react";

const MobileSaveButton = props => {
  return (
    <button
      className="btn btn-warning btn-lg"
      value={"save"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileSaveButton;
